import columnList from '../../components/Table/columns';
export const getContinentKeys = (key) => {
	const keyMap = {
		Americas: ['NA', 'SA'],
		Europe: ['EU'],
		Africa: ['AF'],
		Asia: ['AS'],
		Oceania: ['OC'],
	};
	return keyMap[key] || [];
};
export const getColumns =
	(callback, isPageWide, type = 'default') =>
	() => {
		let columns = columnList[type] || [];
		if (!isPageWide) {
			columns = columns.filter((col) => col.desktopOnly !== true);
		}
		callback(columns);
	};
export const filterByCountry = ({ fullList, country }) => {
	const SHIFT_COUNT = 1;
	let countryIdx = fullList.findIndex((item) => {
		return [country, country?.value].includes(item.iso2c);
	});
	const shiftedIndex = countryIdx - SHIFT_COUNT;
	if (shiftedIndex < 0) countryIdx = 0;
	if (shiftedIndex > fullList.length - 20) countryIdx = fullList.length - 20;
	else countryIdx = shiftedIndex;
	return fullList.splice(countryIdx);
};
export const filterByContinent = ({ fullList, continent }) => {
	const keys = getContinentKeys(continent);
	return fullList.filter((item) => {
		return keys.includes(item?.continent);
	});
};
